import { render, staticRenderFns } from "./activity-detail-h5.vue?vue&type=template&id=3cff1691&scoped=true&"
import script from "./activity-detail-h5.vue?vue&type=script&lang=js&"
export * from "./activity-detail-h5.vue?vue&type=script&lang=js&"
import style0 from "./activity-detail-h5.vue?vue&type=style&index=0&id=3cff1691&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cff1691",
  null
  
)

export default component.exports